<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
export default {
  name: 'app',
  watch:{
    $route(to, from) {
      this.deleteLastService(to.path, from.path)
    }
  },
  methods: {
    deleteLastService(toPath, fromPath) {
      let matchRes = fromPath.match(/\/welcome\/services\/[\w\-]+\/demos\/[\w\-]+/)
      if (matchRes && toPath != '/welcome') {
        sessionStorage.removeItem('lastService')
      }
    }
  }
}
</script>

<style lang="scss">
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/scss/font-awesome.scss';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/scss/simple-line-icons.scss';
</style>
<style>
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './assets/scss/style';
</style>

<style>
  .el-input__inner {
    display: block;
    width: 100%;
    height: initial;
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    line-height: 1.5;
    color: #3e515b;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #c2cfd6;
    border-radius: 0;
    -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  }
  .el-input.is-disabled .el-input__inner {
    color: #3e515b;
    background-color: #c2cfd6;
    opacity: 1;
  }
  .el-input__icon {
    line-height: initial;
  }
  .el-select-dropdown__item.selected {
    color: #3e515b;
    font-weight: 700;
  }
  .el-select {
    width: 100%;
  }
  .img-carousel {
    height: 480px;
  }
  .img-carousel .w-100 {
    height: 480px;
    width: auto !important;
    margin-left: auto;
    margin-right: auto;
  }
</style>



// WEBPACK FOOTER //
// App.vue?f3f49186